import 'angular';
import { HotkeyCtrl } from './hotkey.ajs';
import { HotkeyDirective } from './hotkey.directive.ajs';

angular.module('app-lite.core.hotkey', [])
  .controller('HotkeyCtrl', HotkeyCtrl)
  .directive('mdsHotkey', HotkeyDirective);
